import { css } from "emotion";
import L from "leaflet";

import { colors } from "@cobliteam/base-components/src/styles/colors";

import plannedPlaceIconUrl from "../icons/ic_planned.svg";

const icon = css`
  filter: drop-shadow(0px 4px 4px ${colors.shadows.getShadow("#07074e", 0.2)});
`;

export const PlannedIcon = new L.DivIcon({
  html: `<img class="${icon}" src="${plannedPlaceIconUrl}" />`,
  iconSize: [27, 33],
  iconAnchor: [13.5, 33],
});
